function CourseDetailsSection({ content }) {
  if (!content) return null;

  const paragraphs = content.includes('\n\n')
    ? content.split('\n\n').filter(Boolean)
    : [content];

  return (
    <section>
      <h2 className="text-xl font-bold text-[#146599]">Course Details</h2>
      <div className="mt-4 space-y-4 text-sm leading-[1.75] text-[#666666] sm:text-[15px]">
        {paragraphs.map((paragraph, index) => (
          <p key={index}>{paragraph}</p>
        ))}
      </div>
    </section>
  );
}

export default CourseDetailsSection;
